import { DEFAULT_LOCALE_UNDERSCORE, getFinalLocale } from '../src/lib/localeInfo';

type LocaleMessages = Record<string, string>;

function normalizeToUnderscoreLocale(locale?: string): string {
  return getFinalLocale(locale).replace(/-/g, '_');
}
export function formatLocale(locale?: string): string {
  return normalizeToUnderscoreLocale(locale).replace(/_/g, '-');
}
export async function getLocaleMessages(locale?: string): Promise<LocaleMessages> {
  const normalized = normalizeToUnderscoreLocale(locale);
  try {
    const m = await import(`./translations/${normalized}.json`);
    return m.default as LocaleMessages;
  } catch {
    const f = await import(`./translations/${DEFAULT_LOCALE_UNDERSCORE}.json`);
    return f.default as LocaleMessages;
  }
}
